import { useSupabaseClient } from '~/composables/useSupabaseClient';
import { useSupabaseUser } from '~/composables/useSupabaseUser';

export default defineNuxtPlugin({
	name: 'user-locale-mapping',
	dependsOn: ['supabase'],
	setup: (nuxtApp) => {
		const supabase = useSupabaseClient();
		const user = useSupabaseUser();

		nuxtApp.hook('i18n:localeSwitched', ({ newLocale }) => {
			if (!user.value) return;

			if (user.value.user_metadata?.locale === newLocale) return;

			supabase.auth.updateUser({
				data: {
					locale: newLocale,
				},
			});
		});

		supabase.auth.onAuthStateChange((state, session) => {
			if (!session || state !== 'INITIAL_SESSION') return;

			const newLocale = (nuxtApp.$i18n as ReturnType<typeof useI18n>).locale.value;

			if (session.user.user_metadata.locale === newLocale) return;

			supabase.auth.updateUser({
				data: {
					locale: newLocale,
				},
			});
		});
	},
});
